import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

const withTourCheck = (WrappedComponent) => {
    return class extends React.Component {
        componentDidMount() {
            const isTourActive = localStorage.getItem("InteRed_IsTourActive")
            if(isTourActive === "true") {
                const tourType = this.props.location.pathname.split("/")[1]            
                this.props.dispatch({ type: `set${tourType}Tour`, [`is${tourType}TourActive`]: true })
                localStorage.setItem("InteRed_IsTourActive", false)
            }
        }
        render() {
            return <WrappedComponent {...this.props} />;
        }
    }
}
export default compose(
    connect(state => state.Tour),  
    withTourCheck
  );


// WEBPACK FOOTER //
// ./src/HOC/withTourCheck.js